import { render, staticRenderFns } from "./ClarificationQuestion.vue?vue&type=template&id=33fdb21a&scoped=true"
import script from "./ClarificationQuestion.vue?vue&type=script&lang=js"
export * from "./ClarificationQuestion.vue?vue&type=script&lang=js"
import style0 from "./ClarificationQuestion.vue?vue&type=style&index=0&id=33fdb21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fdb21a",
  null
  
)

export default component.exports